































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { isOtherMessage } from '../hooks/useCustomMessage';
import { CustomContent, Message } from '../dataType';
import MessageCard from './message-card/index.vue';
import ReactionMessage from './reaction-message/index.vue';
import { VueConstructor } from 'vue';

export default defineComponent({
  components: {
    MessageCard,
    ReactionMessage
  },
  props: {
    source: {
      type: Object as PropType<Message<any>>,
      required: true
    }
  },
  setup(props) {
    const isRobot = computed<boolean>(() => props.source.userId === 0);
    const isOther = computed<boolean>(() => isOtherMessage(props.source));
    const otherContent = computed<CustomContent<any> | undefined>(() => {
      if (isOther.value) {
        return props.source.content as CustomContent<any>;
      }
      return void 0;
    });
    const otherComponent = computed<VueConstructor | undefined>(() => otherContent.value?.component);
    const otherData = computed<VueConstructor | undefined>(() => otherContent.value?.data);
    const showReaction = computed<boolean>(() => {
      return isRobot.value && [
        'ai.receiveRecommendData',
        'ai.receiveRecommendDataFilter',
        'ai.markdown',
        'ai.noneData',
        'ai.issue',
        'ai.sprint.risk.status',
        'ai.receive.report.data'
      ].includes(props.source.type);
    });
    return {
      isRobot,
      isOther,
      otherComponent,
      otherData,
      showReaction
    };
  }
});
